import { render, staticRenderFns } from "./Waybills.vue?vue&type=template&id=03a38ae6&scoped=true&"
import script from "./Waybills.vue?vue&type=script&lang=js&"
export * from "./Waybills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a38ae6",
  null
  
)

export default component.exports